import { Routes } from '@angular/router';
import { LocationComponent } from './location.component';

export const LocationRoute: Routes = [
  {
    path: '',
    component: LocationComponent
  },
];
